import React from 'react';

const Close = ({ size = 24, color = 'currentColor', ...other }) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M18.3641 4.22183L19.7783 5.63605L13.4139 11.9998L19.7783 18.364L18.3641 19.7782L11.9999 13.4138L5.63614 19.7782L4.22192 18.364L10.5859 11.9998L4.22192 5.63605L5.63614 4.22183L11.9999 10.5858L18.3641 4.22183Z"
        fill={color}
      />
    </svg>
  );
};

export default Close;
